<template>
  <component
    v-bind="modal.props"
    :is="modal.component"
    v-for="[name, modal] in $modals.modals.value.entries()"
    :key="name"
    v-model="modal.isOpen"
  />
</template>
